import React, { useContext, useEffect, useState } from "react";
import { Plus, MapPin, Users, Pencil, X, Building2 } from "lucide-react";
import DistributorMasterLayout from "../../../layouts/distributor/DistributorMasterLayout";
import "../../../assets/styles/distributor/DistributorAreaManagement.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

/* =============================================
   MOCK DATA
   ============================================= */
const CITIES = ["Lahore", "Karachi", "Islamabad", "Rawalpindi", "Faisalabad", "Multan"];

const INITIAL_AREAS = [
  { id: 1, name: "DHA Phase 5", city: "Lahore", customers: 12, price: 180, active: true },
  { id: 2, name: "Gulberg III", city: "Lahore", customers: 8, price: 175, active: true },
  { id: 3, name: "Model Town", city: "Lahore", customers: 15, price: 180, active: true },
  { id: 4, name: "Johar Town", city: "Lahore", customers: 7, price: 170, active: true },
  { id: 5, name: "Garden Town", city: "Lahore", customers: 5, price: 175, active: false },
];

/* =============================================
   ADD AREA MODAL
   ============================================= */
const AddAreaModal = ({ city, onClose, onSave, viewAllAreas }) => {
  // const [form, setForm] = useState({ name: "", price: "" });
  // const handle = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  const [name, setName] = useState();
  const { loggedInDistributor, baseUrl } = useContext(AppContext);

  const fetchAllAreas = () => {
    console.log("this is modal", loggedInDistributor.mwcity_id);
  }

  const addNewArea = () => {
    console.log("function called", name);
    const formData = new FormData();
    formData.append('mwcity_id', loggedInDistributor.mwcity_id);
    formData.append('name', name);
    formData.append('mwdistributor_id', loggedInDistributor.id);

    axios.post(`${baseUrl}/distributor/area/addNewArea`, formData, { headers: { 'Content-type': 'multipart-formdata' } })
    .then((res)=>{
      console.log(res.data);
      if(res.data.success == true){
        Swal.fire({
          'text' : 'Wow',
          'content' : res.data.message,
          'confirmButtonText': 'Okay'
        })
      onClose();
      viewAllAreas(loggedInDistributor);
      }
    }).catch((err)=>{
      console.log(err);
    })
  };
  useEffect(() => {
    fetchAllAreas();
  }, []);

  return (
    <div className="distArea-overlay" onClick={onClose}>
      <div className="distArea-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distArea-modal-close" onClick={onClose}><X size={18} /></button>
        <div className="distArea-modal-header">
          {/* <h4>Add Area in {loggedInDistributor.mwcity_id.name}</h4> */}
          <h4>Add Area in</h4>
          <p>Add a new area where you'll deliver milk</p>
        </div>

        <div className="distArea-form-field">
          <label>Area Name</label>
          <input
            className="distArea-form-input"
            name="name"
            placeholder="e.g. DHA Phase 7"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>

        {/* <div className="distArea-form-field">
          <label>Price Per Liter (PKR)</label>
          <input
            className="distArea-form-input"
            name="price"
            placeholder="e.g. 180"
            value={form.price}
            onChange={handle}
          />
        </div> */}

        <div className="distArea-modal-footer">
          <button className="distArea-btn-cancel" onClick={onClose}>Cancel</button>
          <button
            className="distArea-btn-green"
            onClick={addNewArea}
          // onClick={() => {
          //   if (form.name.trim()) {
          //     onSave({ name: form.name.trim(), price: parseInt(form.price) || 0 });
          //     onClose();
          //   }
          // }}
          >
            Add Area
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   EDIT AREA MODAL
   ============================================= */
const EditAreaModal = ({ area, onClose, onSave }) => {
  const [form, setForm] = useState({ name: area.name, price: String(area.price) });
  const handle = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  return (
    <div className="distArea-overlay" onClick={onClose}>
      <div className="distArea-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distArea-modal-close" onClick={onClose}><X size={18} /></button>
        <div className="distArea-modal-header">
          <h4>Edit Area</h4>
          <p>Update area details and pricing</p>
        </div>

        <div className="distArea-form-field">
          <label>Area Name</label>
          <input
            className="distArea-form-input"
            name="name"
            value={form.name}
            onChange={handle}
            autoFocus
          />
        </div>

        <div className="distArea-form-field">
          <label>Price Per Liter (PKR)</label>
          <input
            className="distArea-form-input"
            name="price"
            value={form.price}
            onChange={handle}
          />
        </div>

        <div className="distArea-modal-footer">
          <button className="distArea-btn-cancel" onClick={onClose}>Cancel</button>
          <button
            className="distArea-btn-green"
            onClick={() => {
              onSave({ name: form.name.trim(), price: parseInt(form.price) || 0 });
              onClose();
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   AREA CARD
   ============================================= */
const AreaCard = ({ area, onEdit, onToggle }) => (
  <div className={`distArea-card ${!area.status == 'active' ? "inactive" : ""}`}>
    <div className="distArea-card-top">
      <div>
        <span className="distArea-card-name">{area.mwarea.name}</span>
        <span className="distArea-card-city">{area.mwcity_id}</span>
      </div>
      <div className="distArea-card-actions">
        {/* Edit pencil */}
        <button
          className="distArea-edit-btn"
          title="Edit Area"
          onClick={() => onEdit(area)}
        >
          <Pencil size={15} />
        </button>

        {/* Toggle switch */}
        <label className="distArea-toggle">
          <input
            type="checkbox"
            checked={area.status == 'active'}
            onChange={() => onToggle(area.id)}
          />
          <span className="distArea-toggle-slider" />
        </label>
      </div>
    </div>

    <div className="distArea-card-bottom">
      <div className="distArea-customers">
        <Users size={14} />
        <span>{area.customers} customers</span>
      </div>
      {/* Price badge — fades when inactive */}
      <span className={`distArea-price-badge ${!area.active ? "faded" : ""}`}>
        PKR {area.price}/L
      </span>
    </div>
  </div>
);

/* =============================================
   MAIN PAGE
   ============================================= */
const AreaManagementContent = () => {
  // const [areas, setAreas]           = useState(INITIAL_AREAS);
  const [areas, setAreas] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [distributorAreaId, setDistributorAreaId] = useState();
  const [showAdd, setShowAdd] = useState(false);
  const [editArea, setEditArea] = useState(null);

  const { baseUrl, loggedInDistributor } = useContext(AppContext);

  /* Filtered by city */
  const filtered = areas.filter((a) => a.city === selectedCity);

  /* Stats */
  const activeCount = filtered.filter((a) => a.active).length;
  const inactiveCount = filtered.filter((a) => !a.active).length;
  const totalCustomers = filtered.reduce((s, a) => s + a.customers, 0);

  /* Handlers */
  // const handleAdd = ({ name, price }) => {
  //   setAreas((prev) => [
  //     ...prev,
  //     { id: Date.now(), name, city: selectedCity, customers: 0, price, active: true },
  //   ]);
  // };

  // 

  const handleEdit = ({ name, price }) => {
    const formData = new FormData();
    formData.append("id", editArea.id);
    formData.append("name", name);
    formData.append("price", price);

    axios
      .post(`${baseUrl}/distributor/area/updateArea`, formData)
      .then(() => {
        viewAllAreas();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const handleToggle = (id) => {
  //   setAreas((prev) =>
  //     prev.map((a) => (a.id === id ? { ...a, active: !a.active } : a))
  //   );
  // };

  //   const handleAdd = ({ name, price }) => {
  //   const formData = new FormData();
  //   formData.append("name", name);
  //   formData.append("price", price);
  //   formData.append("mwcity_id", selectedCity.id);

  //   axios
  //     .post(`${baseUrl}/distributor/area/addNewArea`, formData)
  //     .then((res) => {
  //       if (res.data.success) {
  //         viewAllAreas(); // refresh
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleToggle = (id) => {
  //   // const newStatus = area.status ? 0 : 1;
  //   const formData = new FormData();
  //   formData.append("id", id);

  //   axios
  //     .post(`${baseUrl}/distributor/area/updateStatus`, formData)
  //     .then(() => {
  //       viewAllAreas(); 
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleToggle = (area) => {
  const newStatus = area.status === 'active' ? 'inactive' : 'active';

  const formData = new FormData();
  formData.append("id", area.id);
  formData.append("status", newStatus);

  axios
    .post(`${baseUrl}/distributor/area/updateStatus`, formData)
    .then(() => {
      Swal.fire("Done!", "Status updated", "success");
      const distributorId = JSON.parse(localStorage.getItem('loggedInDistributor'));
      viewAllAreas(distributorId); // refresh list
    })
    .catch((err) => {
      console.log(err);
    });
};

  const viewAllAreas = (distributorId) => {
    console.log(distributorId);
    const formData = new FormData();
    // formData.append("mwcity_id", selectedCity.id);
    // formData.append("mwcity_id", distributorId.mwcity_id);
    formData.append("mwdistributor_id", distributorId.id);

    axios
      .post(`${baseUrl}/distributor/area/getAreas`, formData)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setAreas(res.data.areas);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log(JSON.parse(localStorage.getItem('loggedInDistributor')))
    console.log("logged", loggedInDistributor)
    const distributorId = JSON.parse(localStorage.getItem('loggedInDistributor'));
    viewAllAreas(distributorId);
    // setDistributorAreaId(distributorId);

  }, []);

  // useEffect(() => {
  //   if (selectedCity?.id) {
  //     viewAllAreas();
  //   }
  // }, [selectedCity]);

  return (
    <div className="distArea-page">

      {/* Header */}
      <div className="distArea-header-row">
        <div className="distArea-title">
          <h2>Area Management</h2>
          <p>Manage your service areas and pricing</p>
        </div>
        {/* <button className="distArea-add-btn" onClick={handleAdd}> */}
        <button className="distArea-add-btn" onClick={() => setShowAdd(true)}>
          <Plus size={15} /> Add Area
        </button>
      </div>

      {/* City Selector */}
      <div className="distArea-city-bar">
        <Building2 size={18} />
        <span className="distArea-city-label">Your City:</span>
        {/* <select
          className="distArea-city-select"
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
        >
          {CITIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select> */}
      </div>

      {/* Stats */}
      <div className="distArea-stats-row">
        {/* {console.log("ths is area",areas)} */}

        <div className="distArea-stat-card">
          <div className="distArea-stat-icon green"><MapPin size={18} /></div>
          <div className="distArea-stat-text">
            <span>Active Areas</span>
            <h4>{activeCount}</h4>
          </div>
        </div>
        <div className="distArea-stat-card">
          <div className="distArea-stat-icon blue"><Users size={18} /></div>
          <div className="distArea-stat-text">
            <span>Total Customers</span>
            <h4>{totalCustomers}</h4>
          </div>
        </div>
        <div className="distArea-stat-card">
          <div className="distArea-stat-icon gray"><MapPin size={18} /></div>
          <div className="distArea-stat-text">
            <span>Inactive Areas</span>
            <h4>{inactiveCount}</h4>
          </div>
        </div>
      </div>

      {/* Area Cards */}
      <div className="distArea-cards-grid">
        {filtered.length === 0 ? (
          <div style={{ gridColumn: "1/-1", textAlign: "center", padding: "60px 20px", opacity: 0.4, fontSize: "0.9rem", color: "var(--tertiary-color)" }}>
            No areas found for {selectedCity}
          </div>
        ) : (
          areas.map((area) => (
            <AreaCard
              key={area.id}
              area={area}
              onEdit={(a) => setEditArea(a)}
              onToggle={handleToggle}
            />
          ))
        )}
      </div>

      {/* Modals */}
      {showAdd && (
        <AddAreaModal
          city={selectedCity}
          onClose={() => setShowAdd(false)}
        // onSave={handleAdd}
        viewAllAreas={viewAllAreas}
        />
      )}
      {editArea && (
        <EditAreaModal
          area={editArea}
          onClose={() => setEditArea(null)}
          onSave={handleEdit}
        />
      )}
    </div>
  );
};

const DistributorAreaManagement = () => (
  <DistributorMasterLayout>
    <AreaManagementContent />
  </DistributorMasterLayout>
);

export default DistributorAreaManagement;